import React, { useEffect, useRef, useState } from "react";

import { TextField, Typography } from "@material-ui/core";
import { Autocomplete, createFilterOptions } from "@mui/material";

import { getControlId } from "../../utils/Utils";

import ErrorLabel from "../ErrorLabel";
import CancelIcon from "../../assets/svgIcons/Cancel";
import DownIcon from "../../assets/svgIcons/DownIcon";

import dropdownStyles from "./dropdown.style";

import "./index.scss";

const Dropdown = (props) => {
  let {
    value,
    options,
    getOptionLabel,
    disabled,
    onChange,
    onInputChange,
    placeholder,
    errorMsg,
    labelText,
    renderOption,
    onInputBlur,
    inputAdornment,
    customClass,
    ismultiple,
    groupBy,
    getOptionSelected,
    dropdownRef,
    tagSearchLabel,
    isRequired,
    hideClearBtn,
    labelFont,
  } = props;

  const classes = dropdownStyles();
  const MAX_DROPDOWN_OPTIONS = 300;
  const [open, setOpen] = useState(false);
  const inputRef = useRef(null);
  customClass = customClass || "";
  options = options || [];
  const dropdownId = getControlId(labelText, "dropdown");

  useEffect(() => setOpen(false), []);

  const clearIconHandler = () => {
    if (!disabled) {
      const input = inputRef.current;
      const lastValue = input.value;
      input.value = "";
      const event = new Event("input", { bubbles: true });
      const tracker = input._valueTracker;
      if (tracker) {
        tracker.setValue(lastValue);
      }
      input.dispatchEvent(event);
      if (onInputChange) {
        onInputChange("", "clear");
      }
      if (onChange) {
        onChange("", "clear");
      }
      openDropdownPopup();
    }
  };

  const onValChange = (event, value, reason) => {
    if (onChange) {
      onChange(value, reason);
    }
    setOpen(false);
  };

  const onInputValChange = (event, value, reason) => {
    if (onInputChange) {
      onInputChange(value, reason);
    }

    if (reason === "input") {
      openDropdownPopup();
    }
  };

  const openDropdownPopup = () => setOpen(!disabled);
  const onClickListener = () => setOpen(!open && !disabled);

  const onBlur = (event) => {
    setOpen(false);
    if (onInputBlur) {
      onInputBlur(event);
    }
  };

  const getLabel = (option) => {
    let label = option;
    if (getOptionLabel) {
      label = getOptionLabel(option) || "";
    }
    return label;
  };

  const inputEndAdornment = (value) => {
    if (value) {
      return {
        endAdornment: (
          <div className="pointer" onClick={clearIconHandler}>
            {value && !hideClearBtn ? <CancelIcon disabled={disabled} /> : null}
          </div>
        ),
      };
    }
  };

  const renderDropdownInput = (params) => {
    const inputVal = params.inputProps.value;
    const adorment = inputVal && inputAdornment ? inputAdornment(inputVal) : {};
    return (
      <TextField
        inputRef={inputRef}
        {...params}
        InputProps={{
          ...params.InputProps,
          ...adorment,
          ...inputEndAdornment(inputVal),
          className: classes.textfield,
          disableUnderline: true,
        }}
        onBlur={onBlur}
        error={Boolean(errorMsg)}
        placeholder={placeholder}
      />
    );
  };
  const renderTags = (selected) => {
    const renderValue = selected.join(", ");
    return <Typography className={classes.textfield}>{renderValue}</Typography>;
  };

  const getDropdownClasses = () => {
    let classes = "";
    if (open) {
      classes = `${classes} drop-down__input--focus`;
    }
    if (errorMsg) {
      classes = `${classes} drop-down__input--error`;
    }
    return classes;
  };

  const getSearchLabel = (option) =>
    typeof tagSearchLabel === "function"
      ? tagSearchLabel(option)
      : getLabel(option);

  const filterOptions = createFilterOptions({
    matchFrom: "any",
    limit: MAX_DROPDOWN_OPTIONS,
    stringify: (option) => getSearchLabel(option),
  });

  return (
    <>
      <div className={`${getDropdownClasses()} ${customClass}`}>
        {labelText && (
          <label
            className={`${labelFont} dupont-form-label wrapText`}
            disabled={disabled}
          >
            {labelText} {isRequired && <span style={{ color: "red" }}>*</span>}
          </label>
        )}
        <div id={dropdownId + "_container"} onClick={onClickListener}>
          <Autocomplete
            id={dropdownId}
            open={open}
            popupIcon={<DownIcon />}
            closeicon=""
            filterOptions={filterOptions}
            ref={dropdownRef}
            multiple={ismultiple}
            disabled={disabled}
            value={value || null}
            onChange={onValChange}
            options={options}
            getOptionLabel={getLabel}
            className={`${classes.input}`}
            classes={{ option: classes.option }}
            renderInput={renderDropdownInput}
            onInputChange={onInputValChange}
            renderTags={renderTags}
            getoptionselected={getOptionSelected}
            groupBy={groupBy}
            renderOption={renderOption}
          />
        </div>
        {errorMsg && <ErrorLabel message={errorMsg} />}
      </div>
    </>
  );
};

export default Dropdown;
